import { Button } from '@dextech-ai/dex-design-system'
import Toast from '@/components/Toast'
import usePage from '@/hooks/use-page'
import useStepList from '@/hooks/use-step-list'
import useToast from '@/hooks/use-toast'
import { useNavigate, useQuery } from '@/lib/router-dom'
import DexLeftComponent from '@/components/DexLeftComponent';
import { logout } from '@/redux/actions/auth.js'
import twoFactorAuthenticatication from '@/services/api/twoFactorAuthenticatication'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@dextech-ai/dex-design-system'

const Page = () => {

	/*=================================================
		General
	/================================================*/

	usePage({ title: 'Reset Two Factor Authentication' })

	const { navigate } = useNavigate()
	const dispatch = useDispatch()
	const user = useSelector(state => state.auth.user)

	const { register, handleSubmit, formState: { errors, isValid } } = useForm({
		mode: 'onChange'
	})

	const toastType = {
		success: "success",
		error: "error"
	}

	const query = useQuery()

	const token = query.get("token");
	const emailAddress = query.get("email");

	const { toastList, addToastMessage } = useToast()

	async function reset2fa() {
		axios.defaults.headers.post['Authorization'] = `Bearer ${token}`
		const [error] = await twoFactorAuthenticatication.resetTfa()

		if (error) {
			return addToastMessage("Failed to reset Two-Factor Authentication.", toastType.error)
		}

		delete axios.defaults.headers.post['Authorization']

		goToStep(3)
	}

	useEffect(() => {
		if (token) {
			reset2fa()
		}
	}, [token])

	const [loading, setLoading] = useState(false)

	async function submitHandler() {
		if (loading) {
			return
		}

		const email = user?.email || emailAddress

		setLoading(true)

		const [error] = await twoFactorAuthenticatication.initiateResetTfa({ email: email.toLowerCase() })

		setLoading(false)
		if (error) {
			return addToastMessage("Failed to reset two factor authentication", toastType.error)
		}

		nextStep()
	}

	/*=================================================
		Step
	/================================================*/

	const { step, nextStep, goToStep } = useStepList()

	/*=================================================
		Navigate
	/================================================*/

	function goToLogin() {
		dispatch(logout(navigate))
	}

	return (
		<>
			<div className='layout-login'>
				<DexLeftComponent />
				<div className="layout-login__right">
					<div className="login-box">
						{
							step === 1 && (
								<>
									<div className="reset-tfa-box__title">Trouble With Security Code?</div>
									<div className="reset-tfa-box__desc">We will send you a reset link to your registered email address.</div>
									<Box mt={8}>
										<form id="tfaForm" onSubmit={handleSubmit(submitHandler)}>
											<div className="reset-tfa-box__form__cols">
												<div className="reset-tfa-box__form__action">
													<Button id="send-link-security-code-button" type="submit" fullWidth style={{ maxWidth: '168px' }} loading={loading} iconOnly={loading} aria-label={loading ? 'Sending link' : undefined}>Send Link</Button>
													{!emailAddress && (
														<div className='link reset-tfa-box__form__action__bottom' data-testid="log-in" onClick={() => goToLogin()}>Back</div>
													)}
												</div>
											</div>
										</form>
									</Box>
								</>
							)
						}
						{
							step === 2 && (
								<>
									<div className="reset-tfa-box__title">Reset Link Sent!</div>
									<div className="reset-tfa-box__desc">We sent you a secure link to reset your password. Please check your email.</div>
									<Button onClick={() => goToLogin()} fullWidth style={{ maxWidth: '168px' }}>Back to Log In</Button>
								</>
							)
						}
						{
							step === 3 && (
								<>
									<div className="reset-tfa-box__title">Reset 2 Factor Authentication</div>
									<div className="reset-tfa-box__desc">We have successfully reset Two Factor Authentication for your credentials. Please log in and activate the Two Factor Authentication.</div>
									<Button onClick={() => goToLogin()} fullWidth style={{ maxWidth: '168px' }}>Log In</Button>
								</>
							)
						}
					</div>
				</div>
			</div>
			<Toast toastList={toastList} />
		</>
	)
}
export default Page
